// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  connectFirestoreEmulator,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from "firebase/firestore";
import { isVpcMode } from "./utils/vpcMode";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Define the FirebaseConfig type to fix TypeScript errors
type FirebaseConfig = {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId?: string;
};

// Get Firebase configuration from individual environment variables
const firebaseConfig: FirebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_APIKEY as string,
  authDomain: import.meta.env.VITE_FIREBASE_AUTHDOMAIN as string,
  projectId: import.meta.env.VITE_FIREBASE_PROJECTID as string,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGEBUCKET as string,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGINGSENDERID as string,
  appId: import.meta.env.VITE_FIREBASE_APPID as string,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENTID as string
};

// Validate required fields without logging their values
const requiredFields = ['apiKey', 'authDomain', 'projectId', 'storageBucket', 'messagingSenderId', 'appId'] as const;
const missingFields: string[] = [];

for (const field of requiredFields) {
  if (!firebaseConfig[field]) {
    missingFields.push(field);
    console.error(`Firebase configuration is missing required field: ${field}. Please ensure the VITE_FIREBASE_${field.toUpperCase()} environment variable is set.`);
  }
}

// Throw error with all missing fields if any are missing
if (missingFields.length > 0) {
  throw new Error(`Firebase configuration is missing required fields: ${missingFields.join(', ')}. Please ensure the corresponding VITE_FIREBASE_* environment variables are set.`);
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const firestore = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
});
// A VPC browser must never reach Firestore: every read goes through /api, and
// the six VITE_FIREBASE_* values there are stubs. Any query that still slips
// through (a page not yet migrated) would otherwise leave the customer's
// network for firestore.googleapis.com and hang, since the VPC has no egress.
// Pointing the SDK at a closed local port makes such a call fail inside the
// browser instead. SaaS is untouched.
if (isVpcMode()) {
  connectFirestoreEmulator(firestore, "127.0.0.1", 1);
}

// Media uses backend-authorized GCS uploads and expiring signed read URLs.
// Do not initialize Firebase Storage: its download-token flow is not used.
export { auth, firestore };
